export enum ContentTypeEnum {
    Journey = 'Journey',
    PulseDimension = 'PulseDimension'
}
